import { StoreContext } from '@roc/feature-app-core';
import { useContext } from 'react';
import { DocumentLibraryContentfulStore } from '../store/documentLibraryContentfulStore';

export const useDocumentLibraryContentfulStore = () =>
  useContext<{
    documentLibraryContentfulStore: DocumentLibraryContentfulStore;
  }>(StoreContext);
